import { render, staticRenderFns } from "./ComponentSectorsOnPlan.vue?vue&type=template&id=4c7bd09a&"
import script from "./ComponentSectorsOnPlan.vue?vue&type=script&lang=ts&"
export * from "./ComponentSectorsOnPlan.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentSectorsOnPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardTitle,VDialog,VSpacer})
